/**
 * Object Name Identifier Layout: [00tt 0000 | vvvv vvvv | vvvv vvvv | iiii iiii]
 */
export var tMask = 0x30000000;
export var vMask = 0x00FFFF00;
export var vIncr = 0x00000100;
export var iMask = 0x000000FF;
export var Mixer = 0x00000001;
// used for integer to float params conversion
export var Unit = 1024;
export var DefaultBus = 1 /* Sound */ | 268435456 /* Bus */;
//# sourceMappingURL=interface.js.map